import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconDocument = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-label="IconDocument"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M2.88 0A2.88 2.88 0 0 0 0 2.88v18.24A2.88 2.88 0 0 0 2.88 24h18.24A2.88 2.88 0 0 0 24 21.12V2.88A2.88 2.88 0 0 0 21.12 0zm12.684 7.48a2 2 0 0 0-.41-.04H8.88q-.206 0-.41.04a.48.48 0 0 0-.31.224 1.1 1.1 0 0 0-.12.6c-.015.21.026.42.12.607.075.111.187.191.317.225q.203.04.409.04h2.154v6.52q0 .246.04.488a.56.56 0 0 0 .25.37c.214.104.45.15.687.132.236.02.474-.026.686-.132a.56.56 0 0 0 .251-.37q.054-.236.053-.48V9.17h2.125q.213.001.422-.04a.48.48 0 0 0 .317-.224 1.04 1.04 0 0 0 .132-.594 1.03 1.03 0 0 0-.132-.607.48.48 0 0 0-.307-.224"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconDocument);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
